export default __webpack_public_path__ + "static/fa-solid-900-c960823f32a8a76e35dc9266f8955af0.eot";